/**
 * Colleges
 */
$(document).on("ready", function () {
  // Add to List
  $(document).on("click", ".college .save", function () {
    const $svbtn = $(this);
    let $errors;

    if (location.search.includes("SchoolID=")) {
      $errors = $("#theCollege .college__errors");
    } else {
      $errors = $svbtn.parents("div.college").find(".college__errors");
    }

    $svbtn.prop("disabled", true);

    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action:'fw_fakeSaveCollege',
        SchoolID: $(this).attr("id"),
      }, // serializes the form's elements.
      dataType: "json",
      success: function (data) {
        $svbtn.prop("disabled", false);

        $errors.empty();

        const success = Array.isArray(data) && data[0] === "success";
        if (success) {
          $svbtn.removeClass("save").removeClass("primary").addClass("remove").addClass("secondary").html("REMOVE<small>FROM LIST</small>");
          return;
        }

        const errors = data.hasOwnProperty("errors") ? data.errors : null;
        if (errors) {
          const visibleSecs = 5000;
          $.each(errors, (index, error) => {
            $errors.append(`<li>${error}</li>`);
          });
          $errors.css({
            opacity: 1,
            display: "flex",
          });
          setTimeout(function () {
            $errors.css({
              opacity: 0,
            });
          }, visibleSecs);
          setTimeout(function () {
            $errors.css({
              display: "none",
            });
          }, visibleSecs + 500);
        }
      },
    });
  });

  // Remove From List
  $(document).on("click", "#theCollege .remove, .my-colleges td.remove span, #resultsList .college .remove", function () {
    var $svbtn = $(this);
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'fw_fakeSaveCollege',
        SchoolID: $(this).attr("id"),
        remove: true,
      }, // serializes the form's elements.
      dataType: "json",
      success: function (data) {
        if (data[0] === "success") {
          if ($svbtn.hasClass("mycollege")) {
            if (!isDebug) window.location.reload();
          } else {
            $svbtn.removeClass("remove").removeClass("secondary").addClass("save").addClass("primary").html("SAVE<small>TO LIST</small>");
          }
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            $cur.children(".errors").append('<p class="error">' + data.errors[i] + "</p>");
          }
        } else {
          $cur.children(".errors").append('<p class="error">' + data + "</p>");
        }
      },
      error: function () {},
    });
  });

  $(document).on("click", ".my-colleges .content:not(#my-careers) td.favorite span", function () {
    var $svbtn = $(this);
    if ($(this).children("i").hasClass("fav")) {
      var rmv = true;
    } else {
      var rmv = false;
    }
    addWaiting();
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: "fw_fakeUpdateFavCollege",
        SchoolID: $(this).attr("id"),
        remove: rmv,
      }, // serializes the form's elements.
      dataType: "json",
      success: function (data) {
        if (data[0] === "success") {
          window.location.reload();
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
            removeWaiting();
          }
        } else {
          //$cur.children('.errors').append('<p class="error">'+data+'</p>');
          removeWaiting();
        }
      },
      error: function () {},
    });
  });

  $(document).on("click", ".my-colleges td.apply span", function () {
    var $svbtn = $(this);
    if ($(this).children("i").hasClass("fav")) {
      var rmv = true;
    } else {
      var rmv = false;
    }
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action:"fw_fakeUpdatePlanToApply",
        SchoolID: $(this).attr("id"),
        remove: rmv,
      }, // serializes the form's elements.
      dataType: "json",
      success: function (data) {
        console.log(data);
        if (data[0] === "success") {
          window.location.reload();
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
          }
        } else {
          //$cur.children('.errors').append('<p class="error">'+data+'</p>');
        }
      },
      error: function () {},
    });
  });
});
